import React from 'react'
import { useTrans } from 'hooks'
import { useRouter } from 'next/router'
import { NewsNode, PaginaNode } from '@gql/graphql'
import { PDPDownloadCard, PlaceholderReact } from '@components/molecules'
import { ArticoliCorrelati, BlogHead, NewsletterSection, Page } from 'components/organisms'
import styles from './BlogDetailTemplate.module.sass'
import { JsonLd, WContainer } from '@components/atoms'
import { Swiper, SwiperSlide } from 'swiper/react'
import { API_HOST, removeHTMLTags } from '@utils/index'
import { BRAND } from '@utils/settings'

interface Props {
  pagina?: PaginaNode
  news?: NewsNode
  mainContent?: any
  showNewsletterBox?: boolean
}

const BlogDetailTemplate = (props: Props) => {
  const {
    pagina = undefined,
    news = undefined,
    mainContent = undefined,
    showNewsletterBox = true,
  } = props

  const t = useTrans()
  const router = useRouter()
  const newsletterItem = {
    name: t(`newsletter_section_title_${process.env.SITE_ID}_${router.locale}`),
    description: t(`newsletter_section_description_${process.env.SITE_ID}_${router.locale}`),
  }

  const correlati = news?.correlati || []

  const newsJsonLd = {
    isAccessibleForFree: true,
    url: `${API_HOST}${news?.url}`,
    title: news?.titolo,
    datePublished: news?.data,
    description: removeHTMLTags(news?.sottotitolo),
    images: news?.mainImage || news?.previewImage ? [news?.previewImage, news?.mainImage] : [],
    body: removeHTMLTags(news?.testo || news?.contenutoIndicizzabile),
    authorName: BRAND,
    publisherName: BRAND,
    publisherLogo: `${API_HOST}/static/images/logo.png`,
  }

  return (
    <Page pagina={pagina} item={news} className={`${styles.root}`}>
      <main className={styles.layout}>
        <BlogHead pagina={pagina} news={news} />
        {!!news.testo && (
          <WContainer variant="xs">
            <div
              className={styles.oldContentNews}
              dangerouslySetInnerHTML={{ __html: news.testo }}
            />
          </WContainer>
        )}
        <div className={styles.content}>
          <PlaceholderReact
            contentTypeId={news?.model}
            objectId={news?.pk}
            pkey={'news_content'}
            serverSideContent={mainContent}
          />
        </div>
        {!!news.documentiVisibili && (
          <WContainer>
            <div className={styles.documenti}>
              <Swiper slidesPerView={'auto'} centerInsufficientSlides spaceBetween={20}>
                {[...news.documentiVisibili].map((x) => (
                  <SwiperSlide key={x.pk}>
                    <PDPDownloadCard
                      x={x}
                      label={`${x.titolo}`}
                      url={x.url}
                      key={x.pk}
                      className={styles.document}
                      catalogo={true}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </WContainer>
        )}
        {showNewsletterBox ? (
          <WContainer>
            <NewsletterSection item={newsletterItem} />
          </WContainer>
        ) : null}
        <ArticoliCorrelati title={t('Articoli correlati')} news={correlati} />
      </main>
      <JsonLd item={newsJsonLd} type={'news'} />
    </Page>
  )
}

export default BlogDetailTemplate
